// Vendors
import { reloadedThemes, VARIANTS } from '@openbank/ziniaweb-ui-components';
// Constants
import {
  INTENTIONAL_NAVIGATION,
  INTENTIONAL_NAVIGATION_OFF,
  INTENTIONAL_NAVIGATION_ON,
} from 'constants/app.constants';

const ENTRYPOINT_HEADER_COMPONENT_PROPS = {
    illustration: { illustration: 'logo_brand_adaptive-converted' },
    variant: VARIANTS.HeaderOnboardingVariantsType.DEFAULT,
    ctv: {
      container: {
        padding: '0px !important',
      },
    },
  },
  HEADER_LAYOUT_STYLED_PROVIDER_THEME = {
    theme: reloadedThemes.cobranded_light_alternative,
  };

export {
  ENTRYPOINT_HEADER_COMPONENT_PROPS,
  HEADER_LAYOUT_STYLED_PROVIDER_THEME,
  INTENTIONAL_NAVIGATION,
  INTENTIONAL_NAVIGATION_OFF,
  INTENTIONAL_NAVIGATION_ON,
};
